import { Link } from "expo-router";
import { Button, Card } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Circle, Text, useMedia, View, XStack, YStack } from "tamagui";

import { api } from "~/utils/api";

export const CallToDoHooks = () => {
  const { sm } = useMedia();

  const { t } = useTranslation("homePage");
  const [slices] = api.slices.hasActualSlices.useSuspenseQuery(undefined, {
    refetchOnMount: true,
  });

  const [task] = api.home.tasksStatus.useSuspenseQuery(undefined, {
    refetchOnMount: true,
  });

  if (!slices?.[0]) {
    return null;
  }

  if (task?.todo.onboarding !== "completed") return null;

  return (
    <View gap={"$2"} width="100%" $sm={{ paddingHorizontal: "$3" }}>
      {slices.slice(0, 4).map(({ title, description, type }) => (
        <Card
          key={type}
          data-id="hooks-notification-card"
          flex={1}
          justifyContent="space-between"
          alignItems="center"
          $gtSm={{
            flexDirection: "row",
            paddingVertical: "$5",
          }}
          $sm={{
            paddingVertical: "$3",
          }}
          gap={"$1"}
        >
          <XStack
            flex={1}
            alignItems="center"
            width={"auto"}
            gap={"$2"}
            $sm={{
              flexDirection: "column",
              gap: "$1",
            }}
          >
            <AlertIcon />

            <YStack
              width={"auto"}
              flex={1}
              gap={"$0.5"}
              alignItems={"flex-start"}
            >
              <Card.Title
                data-id="hooks-notification-title"
                $gtSm={{
                  textAlign: "left",
                  fontSize: "$7",
                  lineHeight: "$7",
                }}
                $sm={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "$6",
                  lineHeight: "$6",
                }}
              >
                {title}
              </Card.Title>
              <Text
                data-id="hooks-notification-description"
                numberOfLines={0}
                flex={1}
                flexShrink={1}
                fontFamily={"$body"}
                fontWeight={"$5"}
                fontSize={"$3"}
                lineHeight={"$3"}
                color={"$gray-600"}
                width={"100%"}
                $sm={{
                  fontSize: "$2",
                  fontWeight: "$4",
                  textAlign: "center",
                }}
              >
                {description}
              </Text>
            </YStack>
          </XStack>
          <Link
            data-id="hooks-notification-link"
            href={`/survey/${type}`}
            asChild
          >
            <Button
              flex={1}
              minWidth={200}
              size="lg"
              rounded="lg"
              variant="primary"
              {...(sm && {
                size: "md",
                width: "100%",
              })}
            >
              {t("call-to-action-card.button")}
            </Button>
          </Link>
        </Card>
      ))}
    </View>
  );
};

const AlertIcon = () => {
  return (
    <Circle height={"$6"} width={"$6"} backgroundColor={"$lightpink-500"}>
      <Text
        fontFamily={"$subtitle"}
        fontWeight={"$6"}
        fontSize={"$7"}
        lineHeight={"$7"}
        textAlign={"center"}
      >
        !
      </Text>
    </Circle>
  );
};
